import React, { useEffect, useState } from "react";
import SidebarNav from "../SidebarNav/SidebarNav";
import {
  logoutUser,
  RESET,
  selectLogoutSuccess,
} from "../../redux/features/auth/AuthSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DayStart from "./DayStart";
import {
  getDayStatus,
  getTillAmount,
  selectDayStatus,
  selectTillAmount,
} from "../../redux/features/dayStart/DayStartSlice";
import DayEnd from "./DayEnd";
import { AdminCashierCounter, useIsAdminOrCashier } from "../../Protect/HiddenLink";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";
import { AdminCashier } from "../Protect/HiddenLink";
import Notification from "../Notification/Notification";

const Navbar = ({ page }) => {
  const dayStatus = useSelector(selectDayStatus);
  const tillAmount = useSelector(selectTillAmount);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isSuccess = useSelector(selectLogoutSuccess);
  const isAdminOrCashier = useIsAdminOrCashier();
  const [showTillAmount, setShowTillAmount] = useState(false);

  useEffect(() => {
    dispatch(getDayStatus());
    if (isAdminOrCashier) {
      dispatch(getTillAmount());
    }
  }, [dispatch, isAdminOrCashier]);

  const logout = async () => {
    dispatch(logoutUser());
  };

  const formatPKR = (amount) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "PKR",
      minimumFractionDigits: 2,
    })
      .format(amount)
      .replace("PKR", "Rs.");
  };
  useEffect(() => {
    if (isSuccess) {
      dispatch(RESET());
      navigate("/login");
    }
  }, [isSuccess, navigate, dispatch]);
  return (
    <div>
      <nav className="bg-[#0D868C] shadow-md md:p-4 px-2 py-3 flex justify-between items-center">
        <div className="flex items-center md:space-x-4 space-x-1">
          <SidebarNav />
          <h1 className="lg:text-xl md:text-[1rem] text-[.9rem] font-semibold text-white">
            {page}
          </h1>
        </div>
        <div className="flex items-center lg:gap-4 gap-2">
          <AdminCashierCounter>
            {/* <div className="md:block hidden lg:text-xl md:text-[1rem] text-[.9rem] font-semibold text-white md:mr-5 mr-1">
              {formatPKR(tillAmount)}
            </div> */}
<AdminCashier>
            {showTillAmount && (
              <div className="sm:block hidden lg:text-xl md:text-[1rem] text-[.9rem] font-semibold text-white md:mr-3 mr-1">
                {formatPKR(tillAmount)}
              </div>
            )}
            <button
              onClick={() => setShowTillAmount(!showTillAmount)}
              className=" bg-[#A9A9A9] text-white px-3 md:py-2 py-[6.5px]  md:rounded-xl rounded-lg "
            >
              {showTillAmount ? (
                <IoMdEye className="size-5 text-white  cursor-pointer" />
              ) : (
                <IoMdEyeOff className="size-5 text-white  cursor-pointer" />
              )}
            </button>
            </AdminCashier>

            {dayStatus ? <DayEnd /> : <DayStart />}
            <Notification />
          </AdminCashierCounter>

          <button
            onClick={logout}
            className=" uppercase bg-[#A9A9A9] text-nowrap md:text-[.9rem] text-[.7rem] md:rounded-xl rounded-lg text-white font-semibold md:px-5 px-3  py-2 "
          >
            sign Out
          </button>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
